import { createContext } from "react";

import { themes } from "./utils/theme";

export const Context = createContext({
  theme: themes.light,
});
